<template>
  <LayoutAdmin @click="activeDropdown = false">
    <section class="px-8 mt-6 w-full overflow-x-hiden">
      <section class="flex justify-between items-center mb-8">
        <div class="flex items-center">
          <h1 class="text-2xl">Users & Roles</h1>
          <ChoiseCompany v-if="!loading.company && options.length" @selected:company="dataCompany = $event" :options="options"
            :dataCompany="dataCompany" />
        </div>
        <div class="flex">
          <Button class="bg-primary rounded text-white mx-2 px-6 py-2" @click="modal.show = true; modal.add = true;">
            Add User</Button>
          <Button class="bg-green-500 rounded text-white mx-2 px-6 py-2"
            @click="modal.show = true; modal.setting = true;">
            Settings</Button>
        </div>
      </section>
      <section class="w-full grid grid-cols-12 gap-4">
        <section class="relative col-span-5">
          <section class="w-full overflow-x-auto custom-scrollbar bg-white" :class="loading.get && 'h-96'" @click="
            showActions = null;
          showReasonNote = null;
          ">
            <section class="flex justify-between items-center border-b">
              <div class="flex items-center p-4">
                <h1 class="text-2xl">Users</h1>
              </div>
              <div class="flex"></div>
            </section>
            <UsersList :users="users.datas" :meta="users.meta" :page="userspage" :limit="userslimit"
              :selected-filter="selectedUserFilter" :is-loading="loading.getUsers"
              @on-selected-filter="onSelectedUserFilter" @on-pagination="onUsersPagination" @on-showModal="onShowModalUser" />
            <NoDataShowing v-if="!loading.get && users.datas.length === 0" />
            <Loading v-if="loading.get" />
          </section>
        </section>
        <section class="relative col-span-7">
          <section class="w-full overflow-x-auto custom-scrollbar bg-white" :class="loading.get && 'h-96'" @click="
            showActions = null;
          showReasonNote = null;
          ">
            <section class="flex justify-between items-center border-b">
              <div class="flex items-center p-4">
                <h1 class="text-2xl">Roles</h1>
              </div>
              <div class="flex"></div>
            </section>
            <RolesList :roles="roles.datas" :meta="roles.meta" :page="rolespage" :limit="roleslimit"
              :selected-filter="selectedUserFilter" :is-loading="loading.getRoles"
              @on-selected-filter="onSelectedUserFilter" @on-pagination="onPagination" />
            <NoDataShowing v-if="!loading.get && roles.datas.length === 0" />
            <Loading v-if="loading.get" />
          </section>
        </section>
      </section>
    </section>
  </LayoutAdmin>
  <Modal :title="modal.title" :showModal="modal.show" @close="
    modal.show = false;
  modeEdit = false;
  clearInputValue();
  ">
    <template #header>
      <ChoiseCompany v-if="options.length" @selected:company="dataCompany = $event" :options="options"
        :dataCompany="dataCompany" />
    </template>
    <section>
      <!--actual component start-->
      <div x-data="setup()">
        <ul class="flex justify-center items-center my-4">
          <template v-for="(tab, index) in tabs" :key="index">
            <li class="cursor-pointer px-4 text-gray-500 border-b-2 w-full text-center"
              :class="activeTab === index ? 'text-primary border-primary' : ''" @click="activeTab = index" v-text="tab">
            </li>
          </template>
        </ul>
        <div class="w-full">
          <div v-show="activeTab === 0">
            <Input v-model="data.addUser.name" type="text" label="Fullname" class="flex-col mt-2" label_class="w-full"
              input_class="mt-2" />
            <Input v-model="data.addUser.email" type="email" label="Email" class="flex-col mt-2" label_class="w-full"
              input_class="mt-2" />
            <Input v-model="data.addUser.password" type="password" label="Password" class="flex-col mt-2"
              label_class="w-full" input_class="mt-2" />
            <section class="mb-8">
              <p class="my-1 text-sm">Role</p>
              <select v-model="data.addUser.role"
                class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm">
                <option :value="null" selected disabled>Assign Role</option>
                <option v-for="(role, index) in roles.datas" :key="index" class="px-2 py-1" value="{{role._id}}">
                  {{ role.name }}
                </option>
              </select>
            </section>
            <section class="flex w-full justify-end">
              <section class="flex w-52 justify-between">
                <Button class="bg-gray-400 w-24 py-2 text-white rounded-md">
                  Cancel
                </Button>
                <Button class="bg-green-500 w-24 py-2 text-white rounded-md" @click="handleAddUser"
                  :disabled="loadingData">
                  Save
                </Button>
              </section>
            </section>
          </div>
          <div v-show="activeTab === 1">
            <section class="mb-8">
              <p class="my-1 text-sm">Role</p>
              <select class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm">
                <option :value="null" selected disabled>Assign Role</option>
                <option class="px-2 py-1" value="Super Admin">
                  Superadmin
                </option>
              </select>
            </section>
            <section class="flex w-full justify-end">
              <section class="flex w-52 justify-between">
                <Button class="bg-gray-400 w-24 py-2 text-white rounded-md">
                  Cancel
                </Button>
                <Button class="bg-green-500 w-24 py-2 text-white rounded-md" @click="handleAddPeriodic"
                  :disabled="loadingData">
                  Save
                </Button>
              </section>
            </section>
          </div>
        </div>
      </div>
      <!--actual component end-->
    </section>
    <template #footer> </template>
  </Modal>
</template>

<script>
import LayoutAdmin from "../../components/Layout/Admin.vue";
import UsersList from "../../components/Setting/UsersList.vue";
import RolesList from "../../components/Setting/RolesList.vue";
import Button from "../../components/Button.vue";
import SwitchButton from "../../components/SwitchButton.vue";
import Loading from "../../components/Loading.vue";
import NoDataShowing from "../../components/NoDataShowing.vue";
import Modal from "../../components/Modal.vue";
import Input from "../../components/Input.vue";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import decryptToken from "@/utils/decryptToken";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import {
  AddPeriodicAPI,
  GetPeriodicAPI,
  EditPeriodicAPI,
  DeletePeriodicAPI,
} from "@/actions/periodic";
import { useToast } from "vue-toastification";
import Select from "@/components/Select/index.vue";
import moment from "moment";
import { ChangeStatusPeriodicAPI } from "@/actions/periodic";
import { GetUsers, AddUsersAPI, GetRoles } from "@/actions/users-and-roles";

export default {
  name: "UsersAndRoles",
  components: {
    LayoutAdmin,
    Button,
    Modal,
    Input,
    ChoiseCompany,
    Select,
    SwitchButton,
    Loading,
    NoDataShowing,
    UsersList,
    RolesList,
  },
  data() {
    return {
      activeDropdown: "",
      superAdmin: false,
      options: [],
      dataCompany: {},
      loadingData: false,
      loading: {
        company: true,
        get: true,
        getUsers: false,
        getRoles: false,
      },
      modal: {
        title: "",
        add: false,
        show: false,
        view: false,
        edit: false,
        manage: false,
        manageRole: false,
        setting: false,
        delete: false,
        deleteRole: false,
      },
      users: { datas: [], meta: {} },
      roles: { datas: [], meta: {} },
      selectedUserFilter: "all",
      userspage: 1,
      rolespage: 1,
      userslimit: 5,
      roleslimit: 5,
      activeTab: 0,
      tabs: ["New User", "From Employees"],
      data: {
        addUser: {
          group_id: "",
          company_id: "",
          name: "",
          email: "",
          password: "",
          role: "",
          status: "",
        },
      },
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.options = response?.data;
      this.dataCompany = response?.data[0];
      this.loading.company = false;
    },
    async handleAddUser() {
      this.loadingData = true;
      const data = {
        ...this.data.addUser,
      };
      console.log(data);
      if (data.role != "") {
        const querySuperAdmin = `?company_id=${this.dataCompany?._id}`;
        const response = await AddUsersAPI({
          companyId: this.dataCompany?._id,
          data: data,
        });
        if (response?.status === 401) {
          this.$router.push("/login");
          this.$store.commit("changeIsLoggedIn", false);
        }
        if (response?.status === 200) {
          // this.handleGetPeriodic();
          this.showMessageStatus(response);
          this.clearInputValue();
          // this.modal.showModal = false;
        }
      } else {
        this.showMessageStatus({ data: { message: "Role harus diperlukan" } });
      }
      this.loadingData = false;
    },
    clearInputValue() {
      for (const key in this.data) {
        this.data[key] = "";
      }
    },
    showMessageStatus(response) {
      if (response.status === 200) {
        this.toast.success(response?.data?.message);
      } else {
        if (response.data.message) {
          this.toast.error(response?.data?.message);
        }
      }
    },
    async handleGetUsers() {
      this.loading.getUsers = true;
      const page = this.userspage || 1;
      const limit = this.userslimit || 5;
      const selectedUserFilter = this.selectedUserFilter;
      const { success, data, meta, code, message } = await GetUsers({
        companyId: this.dataCompany?._id,
        page,
        limit,
        selectedUserFilter,
      });
      if (success) {
        this.users = {
          datas: data,
          meta,
        };
        this.loading.getUsers = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.loading.getUsers = false;
          this.toast.error(message);
        }
      }
    },
    async handleGetRoles() {
      this.loading.getRoles = true;
      // const page = this.rolespage || 1;
      // const limit = this.roleslimit || 5;
      const { success, data, meta, code, message } = await GetRoles({
        companyId: this.dataCompany?._id,
        // page,
        // limit,
      });
      if (success) {
        this.roles = {
          datas: data,
          // meta,
        };
        this.loading.getRoles = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.loading.getRoles = false;
          this.toast.error(message);
        }
      }
    },
    onSelectedUserFilter(value) {
      this.selectedUserFilter = value;
      this.userspage = 1;
      this.handleGetUsers();
    },
    onUsersPagination(value) {
      this.userspage = value;
      this.handleGetUsers();
    },
    onPagination(value) {
      this.rolespage = value;
    },
    onShowModalUser(config) {
      console.log(config);
      if (config.modal.edit) {
        this.modal.title = "Edit User";
        this.modal.edit = true;
        this.modal.show = true;
      }
      if (config.modal.manage) {
        this.modal.title = "Manage User";
        this.modal.manage = true;
        this.modal.show = true;
      }
    },
  },
  watch: {
    dataCompany: {
      handler() {
        this.userspage = 1;
        this.rolespage = 1;
        this.handleGetUsers();
        this.handleGetRoles();
        this.loading.get = false;
      },
      deep: true,
    },
  },
  mounted() {
    const payload = decryptToken();
    this.superAdmin =
      payload?.role === "Super Admin" || payload?.role === "Group Admin";
    this.getAllCompany();
  },
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  height: 5px !important;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #c6c8cc;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}
</style>
